// Shared styles and constants for MAMC components

export const COLORS = {
  primary: '#1e4d8c', // Deep blue
  secondary: '#DAA520', // Gold
  accent: '#DAA520', // Changed from green to gold
  success: '#4CAF50',
  error: '#f44336',
  background: {
    dark: '#111111',
    main: '#111111',
    light: '#1a1a1a',
  },
  text: {
    primary: '#ffffff',
    secondary: '#b0bec5',
    accent: '#DAA520',
    highlight: '#FFE5B4', // Peach color for highlights
    muted: '#808080', // Muted gray for subtle text
  },
  gradient: {
    gold: 'linear-gradient(135deg, #DAA520 0%, #FFD700 100%)',
    dark: 'linear-gradient(135deg, rgba(26,26,26,0.95) 0%, rgba(17,17,17,0.98) 100%)',
  },
};

// Section style constants
export const SECTION_STYLES = {
  countdown: {
    background: 'linear-gradient(135deg, rgba(0,0,0,0.9) 0%, rgba(20,20,20,0.95) 100%)',
    border: '1px solid rgba(218,165,32,0.3)',
    boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
    borderRadius: '20px',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: COLORS.gradient.gold,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '80%',
      height: '1px',
      background: 'linear-gradient(90deg, transparent, rgba(218,165,32,0.3), transparent)',
    },
  },
  ongoingMatches: {
    background: 'linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(30,30,30,0.9) 100%)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(218,165,32,0.2)',
    borderRadius: '16px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.4)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'url("/gallery/pattern.png")',
      opacity: 0.05,
      zIndex: 0,
    },
  },
  topScorers: {
    background: 'linear-gradient(160deg, rgba(20,20,20,0.95) 0%, rgba(0,0,0,0.98) 100%)',
    border: '1px solid rgba(218,165,32,0.15)',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      width: '30%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(218,165,32,0.05))',
      transform: 'skewX(-15deg)',
    },
  },
  groupStandings: {
    background: 'linear-gradient(135deg, rgba(10,10,10,0.97) 0%, rgba(30,30,30,0.95) 100%)',
    border: '1px solid rgba(218,165,32,0.2)',
    borderRadius: '16px',
    boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'radial-gradient(circle at 50% 50%, rgba(218,165,32,0.05) 0%, transparent 70%)',
    },
  },
};

// Add overlay styles for background images
export const overlayStyle = {
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(17, 17, 17, 0.92)',
    zIndex: 1,
  },
  '& > *': {
    position: 'relative',
    zIndex: 2,
  },
};

export const FootballPattern = () => (
  <svg style={{ display: 'none' }}>
    <defs>
      <pattern
        id="football-pattern"
        x="0"
        y="0"
        width="40"
        height="40"
        patternUnits="userSpaceOnUse"
      >
        <path
          d="M20 1L33.5 10.5V29.5L20 39L6.5 29.5V10.5L20 1Z"
          fill="none"
          stroke="rgba(218,165,32,0.1)"
          strokeWidth="1"
        />
        <circle cx="20" cy="20" r="4" fill="none" stroke="rgba(218,165,32,0.1)" strokeWidth="1" />
      </pattern>
    </defs>
  </svg>
);
